export enum WorkflowStatus {
  Draft = "draft",
  Published = "published",
}

